export const SET_SERVICE_DETAILS_ERROR = "SET_SERVICE_DETAILS_ERROR";
export const SET_SERVICE_DETAILS_PAGE = "SET_SERVICE_DETAILS_PAGE";
export const SET_SERVICE_DETAILS_REQUEST = "SET_SERVICE_DETAILS_REQUEST";
export const SET_SERVICE_DETAILS_SUCCESS = "SET_SERVICE_DETAILS_SUCCESS";
